import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import FormattedNumber from '../../../../../../../../../../components/FormattedNumber'
import { getNumberBase } from '../../../../../../../../../../components/FormattedNumber/helpers'

import './style.scss'

export default class ScoringResults extends Component {
    static propTypes = {
        data: PropTypes.object,
        level: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            creditsLimitText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            transactionsLimitText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const {
            translates: { creditsLimitText, transactionsLimitText },
            data,
            level,
        } = this.props

        const [parsedLevel] = level
            .split(',')
            .map((x) => parseInt(x, 10))
            .slice(-1)

        const emptyValue = 'N/A'

        const creditLimitValueBase = getNumberBase(data?.creditLimit?.amount)
        const creditLimitFormatted = !_.isNil(data?.creditLimit?.amount)
            ? data?.creditLimit?.amount / creditLimitValueBase?.base
            : null

        const transactionLimitValueBase = getNumberBase(data?.transactionLimit?.amount)
        const transactionLimitFormatted = !_.isNil(data?.transactionLimit?.amount)
            ? data?.transactionLimit?.amount / transactionLimitValueBase?.base
            : null

        return (
            <div className={'scoring-results-wrap'}>
                <div className={'scoring-results'}>
                    <div className={'scoring-results-title'}>{creditsLimitText}</div>
                    <div className={'scoring-results-value'}>
                        <FormattedNumber
                            value={creditLimitFormatted}
                            currency={data?.creditLimit.currency}
                            displayCurrency
                            displayUnits
                            dontFormatValue
                            customBase={creditLimitValueBase}
                            emptyValue={emptyValue}
                        />
                    </div>
                </div>
                {parsedLevel >= 30 && (
                    <div className={'scoring-results'}>
                        <div className={'scoring-results-title'}>{transactionsLimitText}</div>
                        <div className={'scoring-results-value'}>
                            <FormattedNumber
                                value={transactionLimitFormatted}
                                currency={data?.transactionLimit.currency}
                                displayCurrency
                                displayUnits
                                dontFormatValue
                                customBase={transactionLimitValueBase}
                                emptyValue={emptyValue}
                            />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
